import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import Logo from 'components/Logo';
import AccountButton from './AccountButton';
import LanguageSelect from './LanguageSelect';
import HunnyPrice from './HunnyPrice';
import Notifycation from './Notifycation';
import { Link, NavLink } from 'react-router-dom';
import PersonIcon from '@material-ui/icons/Person';
import { Trans } from 'react-i18next';
import { MODULES } from 'config/constants/modules';
import Dropdown from 'components/Dropdown';
import UserOptionsDropDown from './UserOptionsDropDown';
import MenuIcon from '@material-ui/icons/Menu';
import Navigation from './Navigation';
import { useEventListener } from 'hooks/useEventListener';
import { useWeb3React } from '@web3-react/core';

const TopBar: React.FC = () => {
	const [isSmall, setIsSmall] = useState(window?.screen.width <= 769);
	const { account } = useWeb3React();

	useEventListener({
		type: 'resize',
		listener: (event) => {
			if (window.screen.width <= 768) {
				if (!isSmall) setIsSmall(true);
			} else {
				if (isSmall) setIsSmall(false);
			}
		},
	});

	return (
		<>
			<StyledTopBar className="content-blurable">
				<StyledLeftSide>
					<Navigation>
						<StyledMenuIcon>
							<MenuIcon />
						</StyledMenuIcon>
					</Navigation>
					<Logo isShortMode={isSmall} />
				</StyledLeftSide>
				<StyledNavigationContainer>
					<StyledNavLink exact activeClassName="is-active" to={MODULES.HOME}>
						<span>
							<Trans>Home</Trans>
						</span>
					</StyledNavLink>

					<StyledNavLink activeClassName="is-active" to={MODULES.MARKETPLACE}>
						<span>
							<Trans>Marketplace</Trans>
						</span>
					</StyledNavLink>

					<StyledNavLink activeClassName="is-active" to={MODULES.MYSTERY_BOXES}>
						<span>
							<Trans>Mystery Boxes</Trans>
						</span>
					</StyledNavLink>

					<StyledNavLink activeClassName="is-active" to={MODULES.STAKING}>
						<span>
							<Trans>NFT Staking</Trans>
						</span>
					</StyledNavLink>
					<StyledRedirect href="https://pancakehunny.finance/">
						<span>
							<Trans>Farm</Trans>
						</span>
					</StyledRedirect>
				</StyledNavigationContainer>

				<StyledAccountContainer>
					{account ? (
						<StyledNavLink activeClassName="is-active" to={MODULES.MY_NFT}>
							<span>
								<Trans>My NFT</Trans>
							</span>
						</StyledNavLink>
					) : (
						<></>
					)}

					{/* <StyledHunnyNotifcation>
            <Notifycation />
          </StyledHunnyNotifcation>
          /// TODO not for this version
          
          */}
					<StyledLanguageSelect>
						<LanguageSelect />
					</StyledLanguageSelect>
					<StyledAccountButton>
						<AccountButton />
					</StyledAccountButton>
				</StyledAccountContainer>
			</StyledTopBar>
		</>
	);
};

const StyledLeftSide = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 5px 0;
	max-height: 100%;
`;
const StyledTopBar = styled.div`
	left: 0px;
	position: fixed;
	width: 100vw;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 80px;

	z-index: 5;
	background: #191d25;
	box-shadow: inset 0px -1px 0px #272f52;

	box-sizing: border-box;
	padding: 16px 14px 16px 10px;

	@media (max-width: 1350px) {
		padding: 16px 12px;
	}

	@media (max-width: 768px) {
		&.content-blurable {
			background-image: linear-gradient(
				rgb(25, 29, 37) 10%,
				rgba(21, 29, 40, 0.6) 70%,
				transparent 95%
			);
		}
	}

	@media (max-width: 590px) {
		height: 60px;
	}
`;

const StyledHunnyPrice = styled.div`
	margin-left: 24px;

	@media (max-width: 920px) {
		display: none;
	}
`;

const StyledLanguageSelect = styled.div`
	margin: 24px;

	@media (max-width: 920px) {
		margin: 8px;
	}
`;

const StyledMenuIcon = styled.div`
	display: none;
	user-select: none;
	max-width: 58px;
	padding: 6px;
	border-radius: 8px;
	background: rgba(225, 225, 225, 0.1);
	backdrop-filter: blur(10px);

	svg {
		width: 28px;
		height: 22px;
		color: #e960af;
	}
	@media (max-width: 590px) {
		display: block;
	}
`;

const StyledHunnyNotifcation = styled.div`
	margin: 24px;

	@media (max-width: 425px) {
		margin-left: 10px;
		margin-right: 0;
	}
`;

const StyledPersonIcon = styled(PersonIcon)`
	width: 24px;
	height: 24px;
	color: #fff;
`;

const StyledNavigationContainer = styled.div`
	flex: 1;
	display: flex;
	justify-content: flex-start;
	margin-left: 24px;

	@media (max-width: 685px) {
		display: none;
	}
`;

const StyledAccountButton = styled.div`
	@media (max-width: 1170px) {
		display: none;
	}
`;

const StyledAccountContainer = styled.div`
	display: flex;
	align-items: center;
`;

const StyledRedirect = styled.a`
	height: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;

	font-size: 16px;
	font-style: normal;
	font-weight: bold;

	color: #ffffff;

	padding: 0px ${(props) => props.theme.spacing[3]}px;

	span {
		opacity: 0.6;

		@media (max-width: 780px) {
			font-size: 12px;
		}
	}

	&:hover {
		span {
			transition: 0.2s;
			opacity: 1;
		}
	}

	&.is-active {
		span {
			opacity: 1 !important;
			color: #ec65b3;
			font-weight: bold;
		}
	}

	@media (max-width: 850px) {
		font-size: 14px;
	}
`;

const StyledNavLink = styled(NavLink)`
	height: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;

	font-size: 16px;
	font-style: normal;
	font-weight: bold;

	color: #ffffff;

	padding: 0px ${(props) => props.theme.spacing[3]}px;

	span {
		opacity: 0.6;

		@media (max-width: 780px) {
			font-size: 12px;
		}
	}

	&:hover {
		span {
			transition: 0.2s;
			opacity: 1;
		}
	}

	&.is-active {
		span {
			opacity: 1 !important;
			color: #ec65b3;
			font-weight: bold;
		}
	}

	@media (max-width: 850px) {
		font-size: 14px;
	}
`;

export default TopBar;
